import Error from "next/error";

const Bazaar404 = () => {
  return <Error statusCode={404} />;
};

export default Bazaar404;
